module.exports = __webpack_public_path__ + "static/media/TheGrandValley-Rendering.667ca516.jpg";